import { Button, ButtonPropsSizeOverrides, ButtonPropsVariantOverrides } from '@mui/material';
import { OverridableStringUnion } from '@mui/types';
import React from 'react';

export interface WsButtonProps {
  children: string | React.ReactElement;
  startIcon?: React.ReactElement;
  endIcon?: React.ReactElement;
  onClick?: React.MouseEventHandler;
  fullWidth?: boolean;
  variant?: OverridableStringUnion<
    'text' | 'outlined' | 'contained' | 'white',
    ButtonPropsVariantOverrides
  >;
  disabled?: boolean;
  size?: OverridableStringUnion<'small' | 'medium' | 'large', ButtonPropsSizeOverrides>;
  type?: 'submit' | 'reset' | 'button';
  className?: string;
  id?: string;
}

const WsButton = ({
  children,
  startIcon,
  endIcon,
  onClick,
  fullWidth = false,
  variant = 'contained',
  disabled = false,
  size = 'medium',
  type,
  className,
  id = 'button',
}: WsButtonProps) => (
  <Button
    id={id}
    variant={variant}
    disabled={disabled}
    size={size}
    startIcon={startIcon}
    endIcon={endIcon}
    fullWidth={fullWidth}
    onClick={onClick}
    type={type}
    className={className}
  >
    {children}
  </Button>
);

export default WsButton;
